import { render, staticRenderFns } from "./LawNoteToBeOnInvoiceList.vue?vue&type=template&id=456e2d7c&"
import script from "./LawNoteToBeOnInvoiceList.vue?vue&type=script&lang=js&"
export * from "./LawNoteToBeOnInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./LawNoteToBeOnInvoiceList.vue?vue&type=style&index=0&id=456e2d7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports